import axios from "axios";
const APIBASE = process.env.REACT_APP_API;
// TOKEN ADMIN
const adminAuth = process.env.REACT_APP_ADMINAUTH;

const customer = (token) => {
  const headers = {
    headers: { "x-access-token": token, "x-auth-token": adminAuth },
  };
  const proxyUrl = (customerId) => `${APIBASE}/customers/${customerId}/proxy`;

  const createCustomer = async (data) => {
    const response = await axios.post(
      `${APIBASE}/customers/create`,
      data,
      headers
    );

    if (response.data) {
      return response.data;
    }
    return {};
  };

  const createCustomerList = async (data) => {
    const response = await axios.post(
      `${APIBASE}/customers/create/list`,
      data,
      headers
    );

    if (response.data) {
      return response.data;
    }
    return {};
  };

  const listAllCustomersWebMaster = async () => {
    const response = await axios.get(`${APIBASE}/customers`, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const getCustomerByKey = async (key, value) => {
    const payload = {
      key,
      value,
    };
    const response = await axios.post(
      `${APIBASE}/customers/key`,
      payload,
      headers
    );
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const listUserCustomerById = async (customerId, userId) => {
    const response = await axios.get(`${proxyUrl(customerId)}/user/${userId}`, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const updateUserCustomerById = async (customerId, userId, data) => {
    const response = await axios.put(`${proxyUrl(customerId)}/user/${userId}`, data, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const changePassword = async (customerId, userId, password) => {
    const response = await axios.put(
      `${proxyUrl(customerId)}/user/password/${userId}`,
      { password },
      headers
    );
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const listLastThirtyCustomersIntegrations = async (customerId, userId) => {
    const response = await axios.get(
      `${proxyUrl(customerId)}/customer/integration/${userId}`,
      headers
    );
    if (response.data) {
      return response.data.res;
    }
    return {};
  };

  const deleteUser = async (url, userId) => {
    const response = await axios.delete(`${url}/user/${userId}`);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const deleteUserWebMaster = async (listId) => {
    const payload = {
      listId: listId,
    };
    const response = await axios.post(
      `${APIBASE}/customers/delete/all`,
      payload,
      headers
    );
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const updateCustomer = async (customerId, id, customer) => {
    const response = await axios.put(
      `${proxyUrl(customerId)}/customer/${id}`,
      customer,
      headers
    );
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const deleteCustomer = async (customerId, id) => {
    const response = await axios.delete(`${proxyUrl(customerId)}/customer/${id}`, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const searchByKey = async (customerId, userId, key, value) => {
    const payload = {
      userId: userId,
      key: key,
      value: value,
    };
    const response = await axios.post(
      `${proxyUrl(customerId)}/customer/search/key`,
      payload,
      headers
    );
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const listAllCustomer = async (customerId, userId) => {
    const response = await axios.get(`${proxyUrl(customerId)}/customer/all/${userId}`, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };

  const manageLock = async (listUsers, isBlocked) => {
    const payload = {
      listUsers,
      isBlocked,
    };
    const response = await axios.post(
      `${APIBASE}/customers/blocked/all`,
      payload,
      headers
    );

    if (response.data) {
      return response.data;
    }
    return {};
  };


  const createMultiCustomers = async ({ filterListArr }) => {
    const response = await axios.post(
      `${APIBASE}/customers/createMultiCustomers`,
      filterListArr,
      headers
    );

    if (response.data) {
      return response.data;
    }
    return {};
  };

  const getCustomersByField = async (key, list) => {
    const payload = { key, list };
    const response = await axios.post(`${APIBASE}/customers/list/field`,payload,headers);

    if (response.data) {
      return response.data;
    }
    return [];
  };

  const getSummaryDashboard = async () => {
    const response = await axios.get(`${APIBASE}/customers/dashboard/summary`, headers);
    if (response.data) {
      return response.data;
    }
    return {};
  };


  return {
    listAllCustomersWebMaster,
    createCustomer,
    createMultiCustomers,
    listUserCustomerById,
    updateUserCustomerById,
    changePassword,
    listLastThirtyCustomersIntegrations,
    deleteUserWebMaster,
    updateCustomer,
    deleteCustomer,
    searchByKey,
    listAllCustomer,
    manageLock,
    getCustomerByKey,
    getCustomersByField,
    getSummaryDashboard
  };
};

export default customer;
